import { Box, Button, Flex, FormControl, FormLabel, GridItem, Input, Select, SimpleGrid, Text, Icon, useColorModeValue } from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import { useEffect, useState } from "react";
import { useLoading } from "Providers/LoadingProvider";
import { Field, Form, Formik } from "formik";
import StationsApi from "Api/StationsApi";
import { FaSearch } from "react-icons/fa";
import PrintMode from "components/Buttons/PrintMode";
import Favorites from "Helpers/Favorites";
import { StationDataBody } from "../Admin/Stations";
import { TbTable } from "react-icons/tb";

function StationDataReport() {
    const [ filter, setFilter] = useState({});

    async function loadData(station, day) {
        setFilter({station, day});
    }

    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");

    return (
        <Box
            bg={cardBg}
            borderRadius="xl"
            overflow="hidden"
            boxShadow="md"
            border="1px solid"
            borderColor={borderColor}
            overflowX="auto"
        >
            <Box
                bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                py={5}
                px={6}
            >
                <Flex align="center" gap={3}>
                    <Flex align="center" justify="center" bg="whiteAlpha.200" borderRadius="lg" p={2}>
                        <Icon as={TbTable} color="white" boxSize={5} />
                    </Flex>
                    <Box>
                        <Text color="white" fontWeight="bold" fontSize="xl">Dados da Estação</Text>
                        <Text color="whiteAlpha.800" fontSize="sm">Visualização detalhada de registros da estação</Text>
                    </Box>
                </Flex>
            </Box>
            <Box p={6}>
                <Flex direction="column" w="100%">
                    <Box mb={4}>
                        <FormFilter loadData={loadData} />
                    </Box>
                    <StationDataBody
                        stationId={filter?.station?.id}
                        defaultDay={filter.day}
                        isEmbeded
                    />
                    {
                        filter?.station?.provider == 'INMET' &&
                        <Box mb={2} w="100%" textAlign={"center"} fontSize="sm">
                            Fonte de dados: INMET
                        </Box>
                    }
                    <PrintMode />
                </Flex>
            </Box>
        </Box>
    );
}

function FormFilter({ loadData }) {
    const [stations, setStations] = useState([]);
    const loading = useLoading();
    const favorites = Favorites.get();


    useEffect(() => {
        loadStationOptions();
    }, []);

    async function loadStationOptions() {
        loading.show();
        try {
            let response = await StationsApi.options();
            setStations(response.json);
        } finally {
            loading.hide();
        }
    }

    async function submitHandle(values) {
        loadData(stations.find(x => x.id == values.station_id), values.day);
    }

    const filterBg = useColorModeValue("gray.50", "gray.700");

    return (
        <Formik onSubmit={submitHandle} initialValues={{ station_id: null, day: '' }} enableReinitialize={true}>
            {props => (
                <Form id="reportFilterForm">
                    <Box bg={filterBg} p={4} borderRadius="xl">
                        <Flex flexDirection="row" flexWrap w="100%">
                            <SimpleGrid w="100%" columns={{ sm: 1, lg: 12 }} gap={4}>
                            <GridItem colSpan={{ sm: 1, lg: 6 }}>
                                <Field name="station_id">
                                    {({ field, form }) => (
                                        <FormControl isRequired>
                                            <FormLabel mb="0" htmlFor="station_id" fontWeight="normal">Estação:</FormLabel>
                                            <Select id="station_id" {...field} borderRadius="xl" fontSize="md" placeholder="Selecione a Estação...">
                                                {
                                                    !favorites || !favorites.length ?
                                                        (
                                                            stations?.map(station => (
                                                                <option value={station.id}>{station.text}</option>
                                                            ))
                                                        )
                                                        :
                                                        (
                                                            <>
                                                                <optgroup key="favorites" label="Estações Favoritas">
                                                                    {stations?.map(station => {
                                                                        if (favorites.includes(station.identifier))
                                                                            return (<option value={station.id}>{station.text}</option>);
                                                                        else
                                                                            return "";
                                                                    })}
                                                                </optgroup>
                                                                <optgroup key="others" label="Outras Estações">
                                                                    {stations?.map(station => {
                                                                        if (!favorites.includes(station.identifier))
                                                                            return (<option value={station.id}>{station.text}</option>);
                                                                        else
                                                                            return "";
                                                                    })}
                                                                </optgroup>
                                                            </>
                                                        )
                                                }
                                            </Select>
                                        </FormControl>
                                    )}
                                </Field>
                            </GridItem>
                            <GridItem colSpan={{ sm: 1, lg: 4 }}>
                                <Field name="day">
                                    {({ field, form }) => (
                                        <FormControl>
                                            <FormLabel mb="0" htmlFor="day" fontWeight="normal">Dia:</FormLabel>
                                            <Input id="day" {...field} borderRadius="xl" fontSize="md" type="date" />
                                        </FormControl>
                                    )}
                                </Field>
                            </GridItem>

                            <GridItem colSpan={{ sm: 1, lg: 2 }}>
                                <Button w="100%" type='submit' form='reportFilterForm' bg="brand.500" color="white" _hover={{ bg: "brand.600" }} borderRadius="xl" mt={{ lg: 6 }} leftIcon={<FaSearch />}>
                                    Buscar
                                </Button>
                            </GridItem>
                        </SimpleGrid>
                    </Flex>
                    </Box>
                </Form>
            )}
        </Formik>
    );
}

export default StationDataReport;
